import Icon from './Icon';

export const CloseIcon = (props) => (
    <Icon width='18' height='18' fill='none' {...props}>
        <path
            d='M3.3652 14.7336C3.24187 14.8569 3.24187 15.0569 3.3652 15.1802C3.48852 15.3035 3.68847 15.3035 3.81179 15.1802L9.27271 9.71929L14.7336 15.1802C14.8569 15.3035 15.0569 15.3035 15.1802 15.1802C15.3035 15.0569 15.3035 14.8569 15.1802 14.7336L9.7193 9.2727L15.1802 3.81179C15.3035 3.68847 15.3035 3.48852 15.1802 3.3652C15.0569 3.24187 14.8569 3.24187 14.7336 3.3652L9.27271 8.8261L3.8118 3.3652C3.68848 3.24187 3.48853 3.24187 3.36521 3.3652C3.24189 3.48852 3.24189 3.68847 3.36521 3.81179L8.82611 9.2727L3.3652 14.7336Z'
            className='fill-color-primary group-[.light]:fill-white group-[.only-light]:fill-color-primary dark:fill-white'
        />
    </Icon>
);
